<template>
    <div class="app-container">
        <el-tabs v-model="activetabCrm">
            <el-tab-pane
                v-for="(tab, index) in tabList"
                :label="tab.moduleName"
                :key="index"
                :name="tab.moduleType"
            >
                <component :is="tab.moduleType" tabType="voucherCrm" keep-alive></component>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import CrmReport from "@/views/voucherAdmin/voucherCreateCrmReport";
import CrmCouponBuyData from "@/views/voucherAdmin/voucherCreateCrmBuyData";
import crmSerial from "@/views/voucherAdmin/voucherCreateMutilCrmSerial";
import CrmPayUpdate from "@/views/voucherAdmin/voucherCreateMutilCrmPayUpdate";

import config from "@/common/config.js";
import AjaxHelper from "@/common/js/AjaxHelper";
export default {
    components: {
        crmSerial,
        CrmReport,
        CrmCouponBuyData,
        CrmPayUpdate,
    },
    data() {
        return {
            openloading: false,
            tabList: [],
            activetabCrm: "",
            VoucherCreateApi: config.BASE_Middle_API + "VoucherCreate",
        };
    },
    mounted() {
        this.getCrmModules();
    },

    methods: {
        getCrmModules() {
            const _this = this;
            AjaxHelper.get(_this.VoucherCreateApi + "/getCrmModules")
                .then(function(response) {
                    if (response.success) {
                        _this.tabList = response.result;
                        _this.activetabCrm = _this.tabList[0].moduleType;
                    }
                })
                .catch(function(error) {});
        },
    },
};
</script>
